export default class Accordions {
  constructor() {
    this.accordions = $(".accordions")
    this._idCounter = 0

    this.accordions.each((index, accordions) => {
      const $title = $(accordions).find(".accordion__title")

      $($title).each((index, accordion) => {
        const $accordion = $(accordion)
        const $content = $accordion.next()

        // Ensure the panel has an id so aria-controls can point to it
        if ($content && !$content.attr("id")) {
          $content.attr("id", `accordion-panel-${this._idCounter++}`)
        }

        // Initialize ARIA attributes based on current visibility
        const isVisible = $content && $content.is(":visible")
        $accordion.attr("aria-controls", $content ? $content.attr("id") : "")
        $accordion.attr("aria-expanded", isVisible ? "true" : "false")
        if ($content) $content.attr("aria-hidden", isVisible ? "false" : "true")

        $accordion.on("click", (element) => {
          this.toggle(element.currentTarget)
        })
      })
    })
  }

  toggle(accordion) {
    const $accordion = $(accordion)
    const $content = $(accordion).next()
    const $arrow = $(accordion).find(".accordion__arrow")

    // Toggle visibility with animation and update ARIA after animation completes
    if ($content && $content.length) {
      $content.slideToggle(200, () => {
        const isOpen = $content.is(":visible")
        $accordion.attr("aria-expanded", isOpen ? "true" : "false")
        $content.attr("aria-hidden", isOpen ? "false" : "true")
      })
    }

    if ($arrow && $arrow.length) {
      $arrow.toggleClass("open")
    }
  }
}
